import React from 'react';

import { FieldError, PasswordField } from '#/common/components';
import { Button, Card, CardContent } from '#/components/ui';
import { useChangePassword } from '#/pages/auth/hooks/useChangePassword';

const ChangePassword = ({ setIsChangePassword }) => {
    const {
        handleChangeReset,
        handleSubmitReset,
        changePasswordErrors,
        changePasswordTouched,
        changePasswordValues,
        changePasswordApiLoading,
    } = useChangePassword();
    const handleCancel = () => {
        setIsChangePassword(false);
    };

    return (
        <Card className='w-full max-w-lg rounded-xl shadow-2xl border-none py-12 px-20'>
            <CardContent className='flex flex-col gap-6'>
                <h6 className='text-center text-base font-medium text-gray500'>Please type a new password.</h6>
                <form onSubmit={handleSubmitReset} className='space-y-6'>
                    <div className='space-y-2'>
                        <label htmlFor='newPassword' className='text-sm font-medium text-gray700'>
                            Password
                        </label>
                        <PasswordField
                            id='newPassword'
                            name='newPassword'
                            className='w-full px-4 py-3 border border-borderGray rounded-lg shadow-sm placeholder-gray400'
                            placeholder='••••••••'
                            value={changePasswordValues?.newPassword}
                            onChange={handleChangeReset}
                        />
                        <FieldError error={changePasswordTouched?.newPassword && changePasswordErrors?.newPassword} />
                    </div>
                    <div className='space-y-2'>
                        <label htmlFor='confirmNewPassword' className='block text-sm font-medium text-gray-700'>
                            Confirm Password
                        </label>
                        <PasswordField
                            id='confirmNewPassword'
                            name='confirmNewPassword'
                            className='w-full px-4 py-3 border border-borderGray rounded-lg shadow-sm placeholder-gray400'
                            placeholder='••••••••'
                            value={changePasswordValues?.confirmNewPassword}
                            onChange={handleChangeReset}
                        />
                        <FieldError
                            error={
                                changePasswordTouched?.confirmNewPassword && changePasswordErrors?.confirmNewPassword
                            }
                        />
                    </div>

                    <Button
                        type='submit'
                        disabled={changePasswordApiLoading}
                        className='bg-textPrimary w-full h-11 text-white text-base font-medium py-[10px] shadow-sm'
                    >
                        Change Password
                    </Button>
                </form>

                <div className='text-center'>
                    <Button
                        type='button'
                        variant='link'
                        onClick={handleCancel}
                        className='text-sm text-gray500 hover:underline cursor-pointer'
                    >
                        Cancel
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
};

export { ChangePassword };
